module.exports = __webpack_public_path__ + "static/media/7_Luxury apartment-Brillia Nerimatakanodai - Japan.9fb3e833.jpg";